var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('vue-query-builder',{attrs:{"rules":_vm.rules},model:{value:(_vm.query),callback:function ($$v) {_vm.query=$$v},expression:"query"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }